import React from 'react';
import PropTypes from 'prop-types';
import { FONTAWESOME_VARIANT } from '../../config';

const HeadingWithIcon = props => {
  return <h1>
    <i className={FONTAWESOME_VARIANT + " text-muted mx-2 " + props.icon}></i>
    {props.children}
  </h1>
};

HeadingWithIcon.propTypes = {
  icon: PropTypes.string.isRequired,
  children: PropTypes.any,
};

export default HeadingWithIcon;